export default "__VITE_ASSET__DAVCLPnd__"